import {BulkSourceUpdate, FileId, Source, SourceId, SourceUsageType} from "../../Types";
import {invalidateQueries, q} from "../../state"; // Updated import to include q
import {CURRENT_REGION} from "../../utils/region";
import jsonApi, {addAccountId} from "../jsonApi";

export async function get(sourceId: SourceId): Promise<Source> {
  return jsonApi.get<Source>(`/region/${CURRENT_REGION}/api/tprm/sources/${sourceId}`);
}

export async function delete_(sourceId: SourceId): Promise<"ok"> {
  const res = await jsonApi.delete_<"ok">(`/region/${CURRENT_REGION}/api/tprm/sources/${sourceId}`);
  await invalidateQueries([q.tprm.scopeSources.filter()]);
  return res;
}

export async function update(sourceId: SourceId, sourceUsageType: SourceUsageType, update: boolean): Promise<"ok"> {
  const res = await jsonApi.post<"ok">(
    `/region/${CURRENT_REGION}/api/tprm/sources/${sourceId}/usage/${sourceUsageType}`,
    update,
  );
  await invalidateQueries([q.tprm.source.filter(sourceId), q.tprm.scopeSources.filter()]);
  return res;
}

export async function updateDocumentFile(sourceId: SourceId, fileId: FileId): Promise<"ok"> {
  const res = await jsonApi.post<"ok">(`/region/${CURRENT_REGION}/api/tprm/sources/${sourceId}/file`, fileId);
  await invalidateQueries([q.tprm.source.filter(sourceId), q.tprm.scopeSources.filter()]);
  return res;
}

export async function updateNonAuthoritativeMarkdown(sourceId: SourceId, markdown: string) {
  const res = await jsonApi.post<"ok">(
    `/region/${CURRENT_REGION}/api/tprm/sources/${sourceId}/non_authoritative_markdown`,
    markdown,
  );
  await invalidateQueries([q.tprm.source.filter(sourceId), q.tprm.scopeSources.filter()]);
  return res;
}

export async function bulkUpdate(update: BulkSourceUpdate) {
  const res = await jsonApi.patch<"ok">(`/region/${CURRENT_REGION}/api/tprm/sources`, update);
  await invalidateQueries([q.tprm.source.filter(), q.tprm.scopeSources.filter()]);
  return res;
}

export const downloadMany = async (selectedIds: SourceId[]) => {
  const a = document.createElement("a");
  a.href = addAccountId(
    `/region/${CURRENT_REGION}/api/tprm/sources/download?${new URLSearchParams(
      selectedIds.map(s => ["source_id", s.toString()]),
    ).toString()}`,
  );
  a.click();
};
